import React, { useMemo } from "react"
import { Table, Tag, Typography, message } from "@mimber/ui-web"
import { useTaxRates } from "@mimber/client/mimber-organization"
import { TaxRateActionsDropdown } from "@/components/dropdowns"
import type { ColumnsType } from "@mimber/ui-web"
import type { OrganizationTaxRateDto } from "@mimber/schema"
import type { TaxRatesTableProps } from "./TaxRatesTable.types"

const { Text } = Typography

export const TaxRatesTable: React.FunctionComponent<TaxRatesTableProps> = ({
  className,
  ...tableProps
}) => {
  const { data: response, isLoading, error } = useTaxRates()

  React.useEffect(() => {
    if (error) {
      message.error(`Failed to load tax rates: ${error.message}`)
    }
  }, [error])

  const columns: ColumnsType<OrganizationTaxRateDto> = useMemo(
    () => [
      {
        title: "Name",
        key: "name",
        render: (_, record) => <Text strong>{record.name}</Text>,
      },
      {
        title: "Rate",
        key: "ratePercentage",
        render: (_, record) => <Text>{record.ratePercentage}%</Text>,
      },
      {
        title: "Status",
        key: "isActive",
        render: (_, record) => (
          <Tag color={record.isActive ? "green" : "orange"}>
            {record.isActive ? "Active" : "Inactive"}
          </Tag>
        ),
      },
      {
        title: "Actions",
        key: "actions",
        width: 80,
        render: (_, record) => <TaxRateActionsDropdown taxRate={record} />,
      },
    ],
    []
  )

  return (
    <Table<OrganizationTaxRateDto>
      bordered
      columns={columns}
      dataSource={response?.data || []}
      loading={isLoading}
      rowKey="uuid"
      pagination={false}
      className={className}
      {...tableProps}
    />
  )
}
